import img from '../assets/images/empty-state.svg';

import { ButtonLink, Text } from '../common/components';
import { t } from '../common/i18n';

interface PollEmptyStateProps {
  hasDraft: boolean;
  // Po grace period nelze hlasování zakládat — dlaždice se ukáže bez CTA (jako v Headeru)
  hideCta: boolean;
  // Bez předplatného i hlasovacích tokenů — doplní se vysvětlení bezplatného režimu
  showFreeModeNote: boolean;
}

/**
 * Onboarding dlaždice pro admina bez jediného hlasování — poloprůhledná karta
 * překrývající ilustraci prázdného stavu (krabice zůstávají vidět pod ní).
 */
export const PollEmptyState: React.FC<PollEmptyStateProps> = ({ hasDraft, hideCta, showFreeModeNote }) => {
  return (
    <div className="PollEmptyState">
      <img src={img} alt="" className="PollEmptyState__illustration" />
      <div className="PollEmptyState__card">
        <Text as="div" size="h2" color="Neutral800" align="center">
          {t('Poll.EmptyState.title')}
        </Text>
        <Text as="div" size="body-medium" color="Neutral700" align="center" className="PollEmptyState__text">
          {t('Poll.EmptyState.text')}
        </Text>
        <Text as="div" size="body-medium" color="Neutral700" align="center" className="PollEmptyState__text">
          {t('Poll.EmptyState.invitations')}
        </Text>
        {showFreeModeNote && (
          <Text as="div" size="body-medium" color="Neutral700" align="center" className="PollEmptyState__text">
            {t('Poll.EmptyState.freeMode')}
          </Text>
        )}
        {!hideCta && (
          <ButtonLink
            to="add"
            title={t(`Poll.EmptyState.${hasDraft ? 'continueDraft' : 'cta'}`)}
            iconAfter="arrowRightSmall"
          />
        )}
      </div>
    </div>
  );
};
